import { render, staticRenderFns } from "./CBAG1020.vue?vue&type=template&id=66aa194d&scoped=true"
import script from "./CBAG1020Controller.ts?vue&type=script&lang=ts&external"
export * from "./CBAG1020Controller.ts?vue&type=script&lang=ts&external"
import style0 from "./CBAG1020.vue?vue&type=style&index=0&id=66aa194d&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "66aa194d",
  null
  
)

export default component.exports